var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.125L7.5 11.625L12.5 6.625M5.25 16.625H12.25C13.6501 16.625 14.3502 16.625 14.885 16.3525C15.3554 16.1128 15.7378 15.7304 15.9775 15.26C16.25 14.7252 16.25 14.0251 16.25 12.625V5.625C16.25 4.22487 16.25 3.5248 15.9775 2.99002C15.7378 2.51962 15.3554 2.13717 14.885 1.89748C14.3502 1.625 13.6501 1.625 12.25 1.625H5.25C3.84987 1.625 3.1498 1.625 2.61502 1.89748C2.14462 2.13717 1.76217 2.51962 1.52248 2.99002C1.25 3.5248 1.25 4.22487 1.25 5.625V12.625C1.25 14.0251 1.25 14.7252 1.52248 15.26C1.76217 15.7304 2.14462 16.1128 2.61502 16.3525C3.1498 16.625 3.84987 16.625 5.25 16.625Z",
    stroke: "#C4F538",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuests);
export default __webpack_public_path__ + "static/media/quests.d616057e5b8c881d987ffec4fce044f2.svg";
export { ForwardRef as ReactComponent };